module.exports = __webpack_public_path__ + "static/media/recruit_230_game.1a4501e0.png";